/**
 * @format
 * @flow
 */
import React from "react";
import { Route, Redirect } from "react-router-dom";
// import { connect } from 'react-redux';
import * as RT from "../../constants/Routing";

export default class Auth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated:
        !!localStorage.getItem("token") &&
        !!localStorage.getItem("current_user")
    };
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.userWillTransfer();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate() {
    this.userWillTransfer();
  }

  userWillTransfer = () => {
    if (
      !localStorage.getItem("access_token") ||
      !localStorage.getItem("current_user")
    ) {
      // eslint-disable-next-line react/destructuring-assignment
      if (this.state.isAuthenticated !== false) {
        this.setState({
          isAuthenticated: false
        });
      }
      // eslint-disable-next-line react/destructuring-assignment
    } else if (this.state.isAuthenticated !== true) {
      this.setState({
        isAuthenticated: true
      });
    }
  };

  render = () => {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.isAuthenticated) {
      // eslint-disable-next-line react/no-children-prop
      return <Route children={this.props.children} />;
    }
    return <Redirect to={RT.SIGN_IN_PATH} />;
  };
}

// const mapStateToProps = state => {
//   return state
// };

// export default withRouter(connect(mapStateToProps)(Auth));
